import type { GameProfile } from '../types';

const RED = '#BC4435';
const BLUE = '#2C4F8C';

export const ball24: GameProfile = {
  id: 'ball-24',
  label: '24 Balls (1–24)',
  ballIds: Array.from({ length: 24 }, (_, i) => i + 1),
  colorFor: (id) => (id % 2 === 1 ? RED : BLUE),
  textureStyle: 'standard',
  machineCount: 1,
  resultsPerDraw: 1,
};
